import { defineStore } from "pinia";

export const useCompanyStore = defineStore("company", {
    state: () => ({
        data: null
    }),

    persist: true
});
